var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ol',{staticClass:"flex column"},_vm._l((_vm.contractTerms),function(contractTerm,contractTermKey){return _c('li',{key:contractTermKey},[_vm._v(_vm._s(contractTerm))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }